// https://www.geradorcnpj.com/javascript-validar-cnpj.htm
export const validarCnpj = cnpj => {
  if (!cnpj) {
    return false
  }

  const normalizedCnpj = cnpj
    .toString()
    .replace(/[^a-zA-Z0-9]/g, '')
    .toUpperCase()

  if (normalizedCnpj.length !== 14) {
    return false
  }

  const digitos = normalizedCnpj.substring(12)
  if (!/^\d{2}$/.test(digitos)) {
    return false
  }
  const obterValorCaractere = char => char.charCodeAt(0) - 48

  let tamanho = 12
  let numeros = normalizedCnpj.substring(0, tamanho)
  let soma = 0
  let pos = tamanho - 7

  for (let i = tamanho; i >= 1; i--) {
    soma += obterValorCaractere(numeros.charAt(tamanho - i)) * pos--
    if (pos < 2) {
      pos = 9
    }
  }

  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
  if (resultado !== parseInt(digitos.charAt(0), 10)) {
    return false
  }

  tamanho += 1
  numeros = normalizedCnpj.substring(0, tamanho)
  soma = 0
  pos = tamanho - 7

  for (let i = tamanho; i >= 1; i--) {
    soma += obterValorCaractere(numeros.charAt(tamanho - i)) * pos--
    if (pos < 2) {
      pos = 9
    }
  }

  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
  return resultado === parseInt(digitos.charAt(1), 10)
}
